<h1 class="mb-3" *ngIf="!settings" i18n="@@settings_editConsents_title">
  Data Processing Policy Informed Consents
</h1>
<h1
  class="setting-title"
  *ngIf="settings"
  i18n="@@settings_editConsents_managementTitle"
>
  Consents
</h1>
<form [formGroup]="consentDataForm" (ngSubmit)="onSubmit()">
  <ng-container *ngIf="!settings">
    <h3
      class="title-section"
      i18n="@@settings_editConsents_mandatoryConsentTitle"
    >
      Mandatory consent
    </h3>
    <p
      class="desc_section"
      i18n="@@settings_editConsents_mandatoryConsentDescription"
    >
      By checking this box, I agree to appear in the database of the
      NMOSDCopilot® application (surname, first name, place of exercise, RPPS
      number) in order to allow NMOSDCopilot® users to find me. I thus accept
      that Ad Scientiam collects my identification data (surname, first name,
      place of practice, RPPS number) for the sole purpose of displaying them in
      the NMOSD® application.
    </p>
    <div class="btn-group btn-group-toggle form-group checkbox-group">
      <div class="checkbox-form">
        <input
          type="radio"
          id="consentHcpMandatoryProcessing"
          formControlName="consentHcpMandatoryProcessing"
          [value]="false"
          autocomplete="off"
        />
        <label
          for="consentHcpMandatoryProcessing"
          i18n="@@settings_editConsents_consentHcpMandatoryProcessingLabel"
          >I accept</label
        >
      </div>
    </div>
  </ng-container>

  <h3
    class="title-section"
    *ngIf="!settings"
    i18n="@@settings_editConsents_useTitle"
  >
    I would like to be accompanied in my use of NMOSD®
  </h3>
  <p
    class="title_optional"
    i18n="@@settings_editConsents_useOptionalDescription"
  >
    I would like to be accompanied in my use of NMOSD®
  </p>
  <p class="desc_section" i18n="@@settings_editConsents_useDescription">
    I accept that Ad Scientiam contacts me by e-mail to support me and train my
    team in the use of NMOSDopilot® as well as to obtain explanatory brochures
    for my patients and myself.
  </p>
  <div class="form-group">
    <div
      class="btn-group btn-group-toggle"
      ngbRadioGroup
      name="consentHcpOptionalFormation"
    >
      <label
        ngbButtonLabel
        class="radio-form btn"
        [class.active]="profile.consentHcpOptionalFormation"
      >
        <input
          ngbButton
          type="radio"
          formControlName="consentHcpOptionalFormation"
          [value]="true"
        /><span i18n="@@settings_editConsents_Yes">Oui</span>
      </label>
      <label
        ngbButtonLabel
        class="radio-form btn right-radio"
        [class.active]="!profile.consentHcpOptionalFormation"
      >
        <input
          ngbButton
          type="radio"
          formControlName="consentHcpOptionalFormation"
          [value]="false"
        /><span i18n="@@settings_editConsents_No">Non</span>
      </label>
    </div>
  </div>
  <p
    class="title_optional"
    i18n="@@settings_editConsents_newsOptionalDescription"
  >
    I would like to be informed of NMOSD® news
  </p>
  <p class="desc_section" i18n="@@settings_editConsents_newsDescription">
    I accept that Ad Scientiam sends me occasional emails to stay informed of
    MG&Me® news.
  </p>
  <div class="form-group">
    <div
      class="btn-group btn-group-toggle"
      ngbRadioGroup
      name="consentHcpOptionalNews"
    >
      <label
        ngbButtonLabel
        class="radio-form btn"
        [class.active]="profile.consentHcpOptionalNews"
      >
        <input
          ngbButton
          type="radio"
          formControlName="consentHcpOptionalNews"
          [value]="true"
        /><span i18n="@@settings_editConsents_Yes">Oui</span>
      </label>
      <label
        ngbButtonLabel
        class="radio-form btn right-radio"
        [class.active]="!profile.consentHcpOptionalNews"
      >
        <input
          ngbButton
          type="radio"
          formControlName="consentHcpOptionalNews"
          [value]="false"
        /><span i18n="@@settings_editConsents_No">Non</span>
      </label>
    </div>
  </div>
  <p
    class="title_optional"
    i18n="@@settings_editConsents_researchAdvancementOptionalDescription"
  >
    I want to help the advancement of scientific research on Myasthenia!
  </p>
  <p
    class="desc_section"
    i18n="@@settings_editConsents_researchAdvancementDescription"
  >
    I agree that Ad Scientiam may contact me to suggest that I participate in
    studies and/or research in the field of Myasthenia.
  </p>
  <div class="form-group">
    <div
      class="btn-group btn-group-toggle"
      ngbRadioGroup
      name="consentHcpOptionalPanel"
    >
      <label
        ngbButtonLabel
        class="radio-form btn"
        [class.active]="profile.consentHcpOptionalPanel"
      >
        <input
          ngbButton
          type="radio"
          formControlName="consentHcpOptionalPanel"
          [value]="true"
        /><span i18n="@@settings_editConsents_Yes">Oui</span>
      </label>
      <label
        ngbButtonLabel
        class="radio-form btn right-radio"
        [class.active]="!profile.consentHcpOptionalPanel"
      >
        <input
          ngbButton
          type="radio"
          formControlName="consentHcpOptionalPanel"
          [value]="false"
        /><span i18n="@@settings_editConsents_No">Non</span>
      </label>
    </div>
  </div>
  <button
    type="submit"
    *ngIf="!settings"
    [disabled]="!consentDataForm.valid"
    class="btn btn-primary mt-5 w-75"
  >
    <span i18n="@@onboarding_consents_validBtn">Valider</span>
    <span class="icon"
      ><img src="assets/icons/icon-white-arrow-right.svg" alt="arrow"
    /></span>
  </button>
</form>
